module.exports = __webpack_public_path__ + "static/media/0009.b9735a7b.jpg";